module.exports = __webpack_public_path__ + "static/media/it-never-rains-tablet.3616a8db.jpg";